import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';

import ControlRadio from '../ControlRadio';

export interface IRadioWithLabelProps {
    /** Label to display */
    label: string | React.ReactNode;
    /** Description for label */
    description?: React.ReactNode;
    /** Additional meta to display */
    meta?: React.ReactNode;
    /** Display meta first */
    metaFirst?: boolean;
    /** State of Radio */
    checked: boolean;
    /** Disabled */
    disabled?: boolean;
    /** DOM target element name attribute */
    name?: string;
    /** DOM target element id attribute */
    id?: string;
    /** Change event */
    onChange: (event) => void;
    /** Value */
    value?: string;
    /** Data test id for automated tests */
    testId?: string;
}

interface IState {
}

/**
 * ControlRadio extension to display label before Radio element.
 */
class RadioWithLabel extends React.Component<IRadioWithLabelProps, IState> {
    static displayName: string = 'RadioWithLabel';

    private nodeRadiobutton;

    render () {
        return (
            <React.Fragment>
                {!!this.props.meta && !!this.props.metaFirst && (
                    <div className="radio-with-label-meta">{this.props.meta}</div>
                )}
                <div
                    className={classNames(
                        'radio-with-label',
                        {
                            'selected' : this.props.checked,
                            'disabled': this.props.disabled,
                        }
                    )}
                >
                    <ControlRadio
                        checked={this.props.checked}
                        onChange={this.props.onChange}
                        ref={(node) => this.nodeRadiobutton = node}
                        wrapperElement="span"
                        disabled={this.props.disabled}
                        name={this.props.name}
                        value={this.props.value}
                        testId={this.props.testId}
                    />
                    <label
                        htmlFor={this.props.id}
                        className="radio-with-label-label-wrapper"
                        onClick={() => {
                            if (this.nodeRadiobutton) {
                                this.nodeRadiobutton.click();
                            }
                        }}
                    >
                        <span className="radio-with-label-label">
                            {this.props.label}
                        </span>
                        {!!this.props.description && (
                            <span className="radio-with-label-description">{this.props.description}</span>
                        )}
                    </label>
                </div>
                {!!this.props.meta && this.props.metaFirst !== true && (
                    <div className="radio-with-label-meta">{this.props.meta}</div>
                )}
            </React.Fragment>


        );
    }
}

export default (RadioWithLabel);
